import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'ui';

const ViewAllLink = ({ children, to }) => (
  <Link to={to} className="LearnContentGroup-action u-linkBtn">
    <span className="fz-bigger">{children}</span>
    <Icon name="arrow-right" className="ml-4" />
  </Link>
);

export default ViewAllLink;
